<template>
  <div>
    <div
      v-if="hasImage"
      class="highlight-image"
    >
      <AImage
        :img="getImage"
        :preset="getPreset"
        :ratio="getRatio"
        responsive
        contain
      />
    </div>

    <div class="highlight-content">
      <div
        v-if="getHighlightLeadline"
        class="highlight-leadline"
      >
        <h4>{{ getHighlightLeadline }}</h4>
      </div>
      <div
        v-if="getHighlightTitle"
        class="highlight-title"
      >
        <h2>{{ getHighlightTitle }}</h2>
      </div>
      <div
        v-if="getHighlightDescription"
        class="highlight-description"
        v-html="getHighlightDescription"
      />
      <div
        v-if="hasHighlightButton"
        class="highlight-link"
      >
        <component
          :is="linkComponent"
          :to="{ path: getHighlightButton.url }"
          :href="$options.filters.toUrl(getHighlightButton.url)"
          target="_blank"
        >{{ getHighlightButton.title || getHighlightButton.url }}</component>
      </div>
    </div>
  </div>
</template>

<script>

import layoutMixin from './layouts-mixin'

export default {
  name: 'sp-feature-highlight-image-leadline-title-description-button',
  mixins: [layoutMixin]
}
</script>

<style lang="scss" scoped>
  @import '~@scss/custom.scss';

  ::v-deep .highlight-image {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-bottom: 2em;
    @include media-breakpoint-up(sm) {
      margin-bottom: 0;
      width: auto;
      min-width: 35%;
      max-width: 35%;
    }
    .a-image.responsive.contain img {
      position: relative;
    }
  }

  .highlight-content {
    flex-direction: column;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .highlight-title {
    margin: .75em 0em;
    color: var(--main-text-heading-color);
  }
  .highlight-description{
    margin-bottom:1rem;
  }
  .highlight-leadline,
  .highlight-description {
    color: var(--main-text-color);
  }
  .highlight-link {
    a {
      font-size:1.2em;
      color:var(--main-highlight-color);
    }
  }
</style>
